import { derived } from 'svelte/store';
import { levels, firstLevel } from '../levels/';
import { readWriteStore } from '../utils/read-write-store';
import { urlFragment } from './url-fragment';
export const currentLevelKey = derived(urlFragment, (frag) => {
    return frag.level || firstLevel;
});
export const currentLevel = derived(currentLevelKey, key => levels[key]);
// Controlled by World, tracks whether or not the current level has been won during this session.
export const currentLevelWin = readWriteStore(undefined);
// Keep a local copy of the current level key.
let localLevelKey = null;
currentLevelKey.subscribe(key => localLevelKey = key);
export function startLevel(name) {
    urlFragment.setUrlKeys({
        level: name,
        tab: 'menu',
        menu: 'levelInfo',
    });
}
export function gotoNextLevel() {
    const levelOrder = Object.keys(levels);
    const index = levelOrder.indexOf(localLevelKey);
    const next = index < 0 || index >= levelOrder.length ? firstLevel : levelOrder[index + 1];
    startLevel(next);
}
